"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointVector = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var EndpointVector;
(function (EndpointVector) {
    EndpointVector["Unknown"] = "UNKNOWN";
    EndpointVector["None"] = "NONE";
    EndpointVector["GitPush"] = "GIT_PUSH";
    EndpointVector["ApplicationRead"] = "APPLICATION_READ";
    EndpointVector["SlackApplication"] = "SLACK_APPLICATION";
    EndpointVector["Sftp"] = "SFTP";
    EndpointVector["Curl"] = "CURL";
    EndpointVector["BrowserUploaded"] = "BROWSER_UPLOADED";
    EndpointVector["BrowserDownloaded"] = "BROWSER_DOWNLOADED";
    EndpointVector["RemovableMediaOut"] = "REMOVABLE_MEDIA_OUT";
    EndpointVector["SyncAppUp"] = "SYNC_APP_UP";
    EndpointVector["SyncAppDown"] = "SYNC_APP_DOWN";
    EndpointVector["Printed"] = "PRINTED";
    EndpointVector["Airdrop"] = "AIRDROP";
    EndpointVector["GitDown"] = "GIT_DOWN";
    EndpointVector["BrowserPaste"] = "BROWSER_PASTE";
    EndpointVector["NetworkStorageIn"] = "NETWORK_STORAGE_IN";
    EndpointVector["NetworkStorageOut"] = "NETWORK_STORAGE_OUT";
})(EndpointVector = exports.EndpointVector || (exports.EndpointVector = {}));
